export const reportOrderCardActionButtonBaseSx = {
  textTransform: "none" as const,
  fontWeight: 600,
  whiteSpace: "nowrap" as const,
  flexShrink: 0,
  px: 1.25,
  minWidth: 0,
  borderColor: "divider",
  color: "text.secondary",
  bgcolor: "background.paper",
  "&:hover": {
    borderColor: "text.secondary",
    bgcolor: "action.hover",
  },
};

export const reportOrderCardActionButtonSx = {
  ...reportOrderCardActionButtonBaseSx,
  borderRadius: 1.5,
};
